import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/freight/groupages/$consolidationId',
}).lazy(() => import('./$consolidationId.lazy').then((d) => d.Route))
